import { defineAsyncComponent as o } from "vue";
const r = {
  components: {
    WIconAddPhone: o(
      () => import("./watson.WIconAddPhone.es.js")
    ),
    WIconAddVisit: o(
      () => import("./watson.WIconAddVisit.es.js")
    ),
    WIconAiPhone: o(
      () => import("./watson.WIconAiPhone.es.js")
    ),
    WIconAlarmClock: o(
      () => import("./watson.WIconAlarmClock.es.js")
    ),
    WIconAlarm: o(() => import("./watson.WIconAlarm.es.js")),
    WIconBack: o(() => import("./watson.WIconBack.es.js")),
    WIconBin: o(() => import("./watson.WIconBin.es.js")),
    WIconBookmark: o(
      () => import("./watson.WIconBookmark.es.js")
    ),
    WIconCalendarBlock: o(
      () => import("./watson.WIconCalendarBlock.es.js")
    ),
    WIconCalendarFilled: o(
      () => import("./watson.WIconCalendarFilled.es.js")
    ),
    WIconCalendarOffPatients: o(
      () => import("./watson.WIconCalendarOffPatients.es.js")
    ),
    WIconCalendarOff: o(
      () => import("./watson.WIconCalendarOff.es.js")
    ),
    WIconCalendarSettings: o(
      () => import("./watson.WIconCalendarSettings.es.js")
    ),
    WIconCalendarShare: o(
      () => import("./watson.WIconCalendarShare.es.js")
    ),
    WIconCalendarWithCheck: o(
      () => import("./watson.WIconCalendarWithCheck.es.js")
    ),
    WIconCalendar: o(
      () => import("./watson.WIconCalendar.es.js")
    ),
    WIconCheckFilled: o(
      () => import("./watson.WIconCheckFilled.es.js")
    ),
    WIconCheck: o(() => import("./watson.WIconCheck.es.js")),
    WIconClick: o(() => import("./watson.WIconClick.es.js")),
    WIconClockFilled: o(
      () => import("./watson.WIconClockFilled.es.js")
    ),
    WIconClock: o(() => import("./watson.WIconClock.es.js")),
    WIconCloseCircle: o(
      () => import("./watson.WIconCloseCircle.es.js")
    ),
    WIconCloseFull: o(
      () => import("./watson.WIconCloseFull.es.js")
    ),
    WIconClose: o(() => import("./watson.WIconClose.es.js")),
    WIconCopy: o(() => import("./watson.WIconCopy.es.js")),
    WIconCut: o(() => import("./watson.WIconCut.es.js")),
    WIconDotMenu: o(
      () => import("./watson.WIconDotMenu.es.js")
    ),
    WIconDoubleCheckFilled: o(
      () => import("./watson.WIconDoubleCheckFilled.es.js")
    ),
    WIconDoubleCheck: o(
      () => import("./watson.WIconDoubleCheck.es.js")
    ),
    WIconDownload: o(
      () => import("./watson.WIconDownload.es.js")
    ),
    WIconDrag: o(() => import("./watson.WIconDrag.es.js")),
    WIconEndCall: o(
      () => import("./watson.WIconEndCall.es.js")
    ),
    WIconEnlarge: o(
      () => import("./watson.WIconEnlarge.es.js")
    ),
    WIconFilters: o(
      () => import("./watson.WIconFilters.es.js")
    ),
    WIconHamburger: o(
      () => import("./watson.WIconHamburger.es.js")
    ),
    WIconHellip: o(() => import("./watson.WIconHellip.es.js")),
    WIconHide: o(() => import("./watson.WIconHide.es.js")),
    WIconInProgress: o(
      () => import("./watson.WIconInProgress.es.js")
    ),
    WIconInfo: o(() => import("./watson.WIconInfo.es.js")),
    WIconLetterNotification: o(
      () => import("./watson.WIconLetterNotification.es.js")
    ),
    WIconLock: o(() => import("./watson.WIconLock.es.js")),
    WIconLogout: o(() => import("./watson.WIconLogout.es.js")),
    WIconMagnifierLess: o(
      () => import("./watson.WIconMagnifierLess.es.js")
    ),
    WIconMagnifierPlus: o(
      () => import("./watson.WIconMagnifierPlus.es.js")
    ),
    WIconMinimalize: o(
      () => import("./watson.WIconMinimalize.es.js")
    ),
    WIconMinusCircle: o(
      () => import("./watson.WIconMinusCircle.es.js")
    ),
    WIconMinus: o(() => import("./watson.WIconMinus.es.js")),
    WIconMoveVisit: o(
      () => import("./watson.WIconMoveVisit.es.js")
    ),
    WIconNegativeFilled: o(
      () => import("./watson.WIconNegativeFilled.es.js")
    ),
    WIconNotifications: o(
      () => import("./watson.WIconNotifications.es.js")
    ),
    WIconOngoing: o(
      () => import("./watson.WIconOngoing.es.js")
    ),
    WIconOpenInFull: o(
      () => import("./watson.WIconOpenInFull.es.js")
    ),
    WIconOut: o(() => import("./watson.WIconOut.es.js")),
    WIconPaperPlane: o(
      () => import("./watson.WIconPaperPlane.es.js")
    ),
    WIconPen: o(() => import("./watson.WIconPen.es.js")),
    WIconPending: o(
      () => import("./watson.WIconPending.es.js")
    ),
    WIconPhoneCall: o(
      () => import("./watson.WIconPhoneCall.es.js")
    ),
    WIconPhone: o(() => import("./watson.WIconPhone.es.js")),
    WIconPlusCircle: o(
      () => import("./watson.WIconPlusCircle.es.js")
    ),
    WIconPlusFilled: o(
      () => import("./watson.WIconPlusFilled.es.js")
    ),
    WIconPlus: o(() => import("./watson.WIconPlus.es.js")),
    WIconProtect: o(
      () => import("./watson.WIconProtect.es.js")
    ),
    WIconQuestionFilled: o(
      () => import("./watson.WIconQuestionFilled.es.js")
    ),
    WIconQuestion: o(
      () => import("./watson.WIconQuestion.es.js")
    ),
    WIconRefreshFilled: o(
      () => import("./watson.WIconRefreshFilled.es.js")
    ),
    WIconRefresh: o(
      () => import("./watson.WIconRefresh.es.js")
    ),
    WIconReorder: o(
      () => import("./watson.WIconReorder.es.js")
    ),
    WIconRepeat: o(() => import("./watson.WIconRepeat.es.js")),
    WIconReply: o(() => import("./watson.WIconReply.es.js")),
    WIconRevert: o(() => import("./watson.WIconRevert.es.js")),
    WIconSandClock: o(
      () => import("./watson.WIconSandClock.es.js")
    ),
    WIconSearch: o(() => import("./watson.WIconSearch.es.js")),
    WIconSettings: o(
      () => import("./watson.WIconSettings.es.js")
    ),
    WIconShare: o(() => import("./watson.WIconShare.es.js")),
    WIconShield: o(() => import("./watson.WIconShield.es.js")),
    WIconShow: o(() => import("./watson.WIconShow.es.js")),
    WIconSortAscending: o(
      () => import("./watson.WIconSortAscending.es.js")
    ),
    WIconSortDescending: o(
      () => import("./watson.WIconSortDescending.es.js")
    ),
    WIconSpeedGauge: o(
      () => import("./watson.WIconSpeedGauge.es.js")
    ),
    WIconSyncDisabled: o(
      () => import("./watson.WIconSyncDisabled.es.js")
    ),
    WIconSyncProblem: o(
      () => import("./watson.WIconSyncProblem.es.js")
    ),
    WIconSyncSuccess: o(
      () => import("./watson.WIconSyncSuccess.es.js")
    ),
    WIconSync: o(() => import("./watson.WIconSync.es.js")),
    WIconUnfold: o(() => import("./watson.WIconUnfold.es.js")),
    WIconUpload: o(() => import("./watson.WIconUpload.es.js")),
    WIconVerticalLines: o(
      () => import("./watson.WIconVerticalLines.es.js")
    ),
    WIconViewAgenda: o(
      () => import("./watson.WIconViewAgenda.es.js")
    ),
    WIconViewDay: o(
      () => import("./watson.WIconViewDay.es.js")
    ),
    WIconViewThreeDays: o(
      () => import("./watson.WIconViewThreeDays.es.js")
    ),
    WIconViewWeek: o(
      () => import("./watson.WIconViewWeek.es.js")
    ),
    WIconWarning: o(
      () => import("./watson.WIconWarning.es.js")
    ),
    WIconArrowDown: o(
      () => import("./watson.WIconArrowDown.es.js")
    ),
    WIconArrowLeft: o(
      () => import("./watson.WIconArrowLeft.es.js")
    ),
    WIconArrowRight: o(
      () => import("./watson.WIconArrowRight.es.js")
    ),
    WIconArrowUp: o(
      () => import("./watson.WIconArrowUp.es.js")
    ),
    WIconCaretLeft: o(
      () => import("./watson.WIconCaretLeft.es.js")
    ),
    WIconCaretRight: o(
      () => import("./watson.WIconCaretRight.es.js")
    ),
    WIconCaretTop: o(
      () => import("./watson.WIconCaretTop.es.js")
    ),
    WIconCaret: o(() => import("./watson.WIconCaret.es.js")),
    WIconAddDocument: o(
      () => import("./watson.WIconAddDocument.es.js")
    ),
    WIconBookOpen: o(
      () => import("./watson.WIconBookOpen.es.js")
    ),
    WIconBubbleChatFilled: o(
      () => import("./watson.WIconBubbleChatFilled.es.js")
    ),
    WIconBubbleChatText: o(
      () => import("./watson.WIconBubbleChatText.es.js")
    ),
    WIconBubbleChatTexting: o(
      () => import("./watson.WIconBubbleChatTexting.es.js")
    ),
    WIconBubbleChat: o(
      () => import("./watson.WIconBubbleChat.es.js")
    ),
    WIconBubbleQAndA: o(
      () => import("./watson.WIconBubbleQAndA.es.js")
    ),
    WIconChart: o(() => import("./watson.WIconChart.es.js")),
    WIconChatOutline: o(
      () => import("./watson.WIconChatOutline.es.js")
    ),
    WIconChecklist: o(
      () => import("./watson.WIconChecklist.es.js")
    ),
    WIconClip: o(() => import("./watson.WIconClip.es.js")),
    WIconClipboard: o(
      () => import("./watson.WIconClipboard.es.js")
    ),
    WIconDiagnosis: o(
      () => import("./watson.WIconDiagnosis.es.js")
    ),
    WIconDocuments: o(
      () => import("./watson.WIconDocuments.es.js")
    ),
    WIconExcel: o(() => import("./watson.WIconExcel.es.js")),
    WIconFileBadge: o(
      () => import("./watson.WIconFileBadge.es.js")
    ),
    WIconFileImage: o(
      () => import("./watson.WIconFileImage.es.js")
    ),
    WIconFilePdf: o(
      () => import("./watson.WIconFilePdf.es.js")
    ),
    WIconFileText: o(
      () => import("./watson.WIconFileText.es.js")
    ),
    WIconFile: o(() => import("./watson.WIconFile.es.js")),
    WIconIdentifier: o(
      () => import("./watson.WIconIdentifier.es.js")
    ),
    WIconInvoice: o(
      () => import("./watson.WIconInvoice.es.js")
    ),
    WIconLayers: o(
      () => import("./watson.WIconLayers.es.js")
    ),
    WIconLeads: o(() => import("./watson.WIconLeads.es.js")),
    WIconListBullets: o(
      () => import("./watson.WIconListBullets.es.js")
    ),
    WIconMailFilled: o(
      () => import("./watson.WIconMailFilled.es.js")
    ),
    WIconMail: o(() => import("./watson.WIconMail.es.js")),
    WIconNoImage: o(
      () => import("./watson.WIconNoImage.es.js")
    ),
    WIconNotes: o(() => import("./watson.WIconNotes.es.js")),
    WIconPaper: o(() => import("./watson.WIconPaper.es.js")),
    WIconPopular: o(
      () => import("./watson.WIconPopular.es.js")
    ),
    WIconPublication: o(
      () => import("./watson.WIconPublication.es.js")
    ),
    WIconQuillWrite: o(
      () => import("./watson.WIconQuillWrite.es.js")
    ),
    WIconReceipt: o(
      () => import("./watson.WIconReceipt.es.js")
    ),
    WIconReports: o(
      () => import("./watson.WIconReports.es.js")
    ),
    WIconRequestQuote: o(
      () => import("./watson.WIconRequestQuote.es.js")
    ),
    WIconResume: o(
      () => import("./watson.WIconResume.es.js")
    ),
    WIconTreatment: o(
      () => import("./watson.WIconTreatment.es.js")
    ),
    WIconArgentina: o(
      () => import("./watson.WIconArgentina.es.js")
    ),
    WIconBrazil: o(() => import("./watson.WIconBrazil.es.js")),
    WIconChile: o(() => import("./watson.WIconChile.es.js")),
    WIconColombia: o(
      () => import("./watson.WIconColombia.es.js")
    ),
    WIconCzechRepublic: o(
      () => import("./watson.WIconCzechRepublic.es.js")
    ),
    WIconGermany: o(
      () => import("./watson.WIconGermany.es.js")
    ),
    WIconItaly: o(() => import("./watson.WIconItaly.es.js")),
    WIconMexico: o(() => import("./watson.WIconMexico.es.js")),
    WIconPeru: o(() => import("./watson.WIconPeru.es.js")),
    WIconPoland: o(() => import("./watson.WIconPoland.es.js")),
    WIconPortugal: o(
      () => import("./watson.WIconPortugal.es.js")
    ),
    WIconSpain: o(() => import("./watson.WIconSpain.es.js")),
    WIconTurkey: o(() => import("./watson.WIconTurkey.es.js")),
    WIconAmazed: o(() => import("./watson.WIconAmazed.es.js")),
    WIconAssistiveTechnology: o(
      () => import("./watson.WIconAssistiveTechnology.es.js")
    ),
    WIconBed: o(() => import("./watson.WIconBed.es.js")),
    WIconBlind: o(() => import("./watson.WIconBlind.es.js")),
    WIconCrutch: o(() => import("./watson.WIconCrutch.es.js")),
    WIconDeaf: o(() => import("./watson.WIconDeaf.es.js")),
    WIconDisabledAccess: o(
      () => import("./watson.WIconDisabledAccess.es.js")
    ),
    WIconDisappointed: o(
      () => import("./watson.WIconDisappointed.es.js")
    ),
    WIconDiversity: o(
      () => import("./watson.WIconDiversity.es.js")
    ),
    WIconDoctor: o(() => import("./watson.WIconDoctor.es.js")),
    WIconHealthCheckup: o(
      () => import("./watson.WIconHealthCheckup.es.js")
    ),
    WIconInfant: o(() => import("./watson.WIconInfant.es.js")),
    WIconNeutral: o(
      () => import("./watson.WIconNeutral.es.js")
    ),
    WIconPatients: o(
      () => import("./watson.WIconPatients.es.js")
    ),
    WIconPeople: o(() => import("./watson.WIconPeople.es.js")),
    WIconPregnant: o(
      () => import("./watson.WIconPregnant.es.js")
    ),
    WIconPublicQAndA: o(
      () => import("./watson.WIconPublicQAndA.es.js")
    ),
    WIconReceiveCash: o(
      () => import("./watson.WIconReceiveCash.es.js")
    ),
    WIconSad: o(() => import("./watson.WIconSad.es.js")),
    WIconSmilingFace: o(
      () => import("./watson.WIconSmilingFace.es.js")
    ),
    WIconStethoscope: o(
      () => import("./watson.WIconStethoscope.es.js")
    ),
    WIconSupport: o(
      () => import("./watson.WIconSupport.es.js")
    ),
    WIconTrust: o(() => import("./watson.WIconTrust.es.js")),
    WIconUserFilled: o(
      () => import("./watson.WIconUserFilled.es.js")
    ),
    WIconUser: o(() => import("./watson.WIconUser.es.js")),
    WIconWebAccessibility: o(
      () => import("./watson.WIconWebAccessibility.es.js")
    ),
    WIconClinic: o(
      () => import("./watson.WIconClinic.es.js")
    ),
    WIconDoor: o(() => import("./watson.WIconDoor.es.js")),
    WIconFacility: o(
      () => import("./watson.WIconFacility.es.js")
    ),
    WIconPharmacy: o(
      () => import("./watson.WIconPharmacy.es.js")
    ),
    WIconPinBordered: o(
      () => import("./watson.WIconPinBordered.es.js")
    ),
    WIconPin: o(() => import("./watson.WIconPin.es.js")),
    WIconClinicCloud: o(
      () => import("./watson.WIconClinicCloud.es.js")
    ),
    WIconDocplanner: o(
      () => import("./watson.WIconDocplanner.es.js")
    ),
    WIconGipo: o(() => import("./watson.WIconGipo.es.js")),
    WIconJameda: o(() => import("./watson.WIconJameda.es.js")),
    WIconTuoTempo: o(
      () => import("./watson.WIconTuoTempo.es.js")
    ),
    WIconCameraCircle: o(
      () => import("./watson.WIconCameraCircle.es.js")
    ),
    WIconCameraDisabled: o(
      () => import("./watson.WIconCameraDisabled.es.js")
    ),
    WIconCameraSwitch: o(
      () => import("./watson.WIconCameraSwitch.es.js")
    ),
    WIconDevices: o(
      () => import("./watson.WIconDevices.es.js")
    ),
    WIconGallery: o(
      () => import("./watson.WIconGallery.es.js")
    ),
    WIconMagicWand: o(
      () => import("./watson.WIconMagicWand.es.js")
    ),
    WIconMegaphone: o(
      () => import("./watson.WIconMegaphone.es.js")
    ),
    WIconMicrophoneDisabled: o(
      () => import("./watson.WIconMicrophoneDisabled.es.js")
    ),
    WIconMicrophone: o(
      () => import("./watson.WIconMicrophone.es.js")
    ),
    WIconMobilePhone: o(
      () => import("./watson.WIconMobilePhone.es.js")
    ),
    WIconMonitorOff: o(
      () => import("./watson.WIconMonitorOff.es.js")
    ),
    WIconMonitor: o(
      () => import("./watson.WIconMonitor.es.js")
    ),
    WIconOffice: o(() => import("./watson.WIconOffice.es.js")),
    WIconOne: o(() => import("./watson.WIconOne.es.js")),
    WIconPlayFilled: o(
      () => import("./watson.WIconPlayFilled.es.js")
    ),
    WIconPlay: o(() => import("./watson.WIconPlay.es.js")),
    WIconPresentationSpeech: o(
      () => import("./watson.WIconPresentationSpeech.es.js")
    ),
    WIconPrint: o(() => import("./watson.WIconPrint.es.js")),
    WIconScanWiFi: o(
      () => import("./watson.WIconScanWiFi.es.js")
    ),
    WIconScreenshot: o(
      () => import("./watson.WIconScreenshot.es.js")
    ),
    WIconTablet: o(() => import("./watson.WIconTablet.es.js")),
    WIconText: o(() => import("./watson.WIconText.es.js")),
    WIconVideoConsultation: o(
      () => import("./watson.WIconVideoConsultation.es.js")
    ),
    WIconViewGrid: o(
      () => import("./watson.WIconViewGrid.es.js")
    ),
    WIconViewSpeaker: o(
      () => import("./watson.WIconViewSpeaker.es.js")
    ),
    WIconAndroid: o(
      () => import("./watson.WIconAndroid.es.js")
    ),
    WIconAppleColor: o(
      () => import("./watson.WIconAppleColor.es.js")
    ),
    WIconFacebookCircleColor: o(
      () => import("./watson.WIconFacebookCircleColor.es.js")
    ),
    WIconFacebookCircle: o(
      () => import("./watson.WIconFacebookCircle.es.js")
    ),
    WIconGlassdoorCircle: o(
      () => import("./watson.WIconGlassdoorCircle.es.js")
    ),
    WIconGoogleColor: o(
      () => import("./watson.WIconGoogleColor.es.js")
    ),
    WIconGoogle: o(() => import("./watson.WIconGoogle.es.js")),
    WIconInstagramCircle: o(
      () => import("./watson.WIconInstagramCircle.es.js")
    ),
    WIconLinkedinCircle: o(
      () => import("./watson.WIconLinkedinCircle.es.js")
    ),
    WIconMessenger: o(
      () => import("./watson.WIconMessenger.es.js")
    ),
    WIconSocialConnection: o(
      () => import("./watson.WIconSocialConnection.es.js")
    ),
    WIconSpotifyCircle: o(
      () => import("./watson.WIconSpotifyCircle.es.js")
    ),
    WIconThumbDown: o(
      () => import("./watson.WIconThumbDown.es.js")
    ),
    WIconThumbUp: o(
      () => import("./watson.WIconThumbUp.es.js")
    ),
    WIconTwitterCircle: o(
      () => import("./watson.WIconTwitterCircle.es.js")
    ),
    WIconWhatsapp: o(
      () => import("./watson.WIconWhatsapp.es.js")
    ),
    WIconYoutubeCircle: o(
      () => import("./watson.WIconYoutubeCircle.es.js")
    ),
    WIconAsterisk: o(
      () => import("./watson.WIconAsterisk.es.js")
    ),
    WIconBadgeLike: o(
      () => import("./watson.WIconBadgeLike.es.js")
    ),
    WIconBankNote: o(
      () => import("./watson.WIconBankNote.es.js")
    ),
    WIconBulb: o(() => import("./watson.WIconBulb.es.js")),
    WIconCircleFilled: o(
      () => import("./watson.WIconCircleFilled.es.js")
    ),
    WIconCircle: o(
      () => import("./watson.WIconCircle.es.js")
    ),
    WIconConnected: o(
      () => import("./watson.WIconConnected.es.js")
    ),
    WIconCreditCard: o(
      () => import("./watson.WIconCreditCard.es.js")
    ),
    WIconDollar: o(
      () => import("./watson.WIconDollar.es.js")
    ),
    WIconEuro: o(() => import("./watson.WIconEuro.es.js")),
    WIconFirstAidPlaster: o(
      () => import("./watson.WIconFirstAidPlaster.es.js")
    ),
    WIconGauntletGloves: o(
      () => import("./watson.WIconGauntletGloves.es.js")
    ),
    WIconGlobe: o(() => import("./watson.WIconGlobe.es.js")),
    WIconGoal: o(() => import("./watson.WIconGoal.es.js")),
    WIconHandBag: o(
      () => import("./watson.WIconHandBag.es.js")
    ),
    WIconHandDiamond: o(
      () => import("./watson.WIconHandDiamond.es.js")
    ),
    WIconLanguage: o(
      () => import("./watson.WIconLanguage.es.js")
    ),
    WIconMicroscope: o(
      () => import("./watson.WIconMicroscope.es.js")
    ),
    WIconParking: o(
      () => import("./watson.WIconParking.es.js")
    ),
    WIconPaymentHistory: o(
      () => import("./watson.WIconPaymentHistory.es.js")
    ),
    WIconPill: o(() => import("./watson.WIconPill.es.js")),
    WIconPuzzle: o(
      () => import("./watson.WIconPuzzle.es.js")
    ),
    WIconQrCode: o(
      () => import("./watson.WIconQrCode.es.js")
    ),
    WIconRectangle: o(
      () => import("./watson.WIconRectangle.es.js")
    ),
    WIconRoundedSquareFilled: o(
      () => import("./watson.WIconRoundedSquareFilled.es.js")
    ),
    WIconRoundedSquare: o(
      () => import("./watson.WIconRoundedSquare.es.js")
    ),
    WIconSaasNewPatient: o(
      () => import("./watson.WIconSaasNewPatient.es.js")
    ),
    WIconSchoolGraduation: o(
      () => import("./watson.WIconSchoolGraduation.es.js")
    ),
    WIconSmart: o(() => import("./watson.WIconSmart.es.js")),
    WIconSpinner: o(
      () => import("./watson.WIconSpinner.es.js")
    ),
    WIconThunder: o(
      () => import("./watson.WIconThunder.es.js")
    ),
    WIconTube: o(() => import("./watson.WIconTube.es.js")),
    WIconVaccine: o(
      () => import("./watson.WIconVaccine.es.js")
    ),
    WIconVirtualReality: o(
      () => import("./watson.WIconVirtualReality.es.js")
    ),
    WIconVirus: o(() => import("./watson.WIconVirus.es.js")),
    WIconWallet: o(
      () => import("./watson.WIconWallet.es.js")
    ),
    WIconZloty: o(() => import("./watson.WIconZloty.es.js")),
    WIconDropdown: o(
      () => import("./watson.WIconDropdown.es.js")
    ),
    WIconEmptyStarThin: o(
      () => import("./watson.WIconEmptyStarThin.es.js")
    ),
    WIconEmptyStar: o(
      () => import("./watson.WIconEmptyStar.es.js")
    ),
    WIconFlowerStar: o(
      () => import("./watson.WIconFlowerStar.es.js")
    ),
    WIconHalfHeart: o(
      () => import("./watson.WIconHalfHeart.es.js")
    ),
    WIconHalfStar: o(
      () => import("./watson.WIconHalfStar.es.js")
    ),
    WIconHeartFilled: o(
      () => import("./watson.WIconHeartFilled.es.js")
    ),
    WIconHeart: o(() => import("./watson.WIconHeart.es.js")),
    WIconRadioButton: o(
      () => import("./watson.WIconRadioButton.es.js")
    ),
    WIconStar: o(() => import("./watson.WIconStar.es.js")),
    WIconThreeStars: o(
      () => import("./watson.WIconThreeStars.es.js")
    )
  }
};
export {
  r as default
};
